var _path, _rect, _path2, _path3, _image, _path4, _image2, _path5, _image3, _path6, _div, _image4, _g, _g2, _g3, _g4, _g5, _g6, _g7, _path7, _path8, _path9, _path10, _path11, _path12, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _path13, _g19, _g20, _g21, _g22, _path14, _path15, _path16, _g23, _g24, _g25, _path17, _g26, _g27, _path18, _path19, _path20, _path21, _g28, _g29, _g30, _g31, _path22, _g32, _path23, _g33, _g34, _g35, _path24, _path25, _path26, _path27, _g36, _g37, _g38;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSolarPowered = function SvgSolarPowered(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 882,
    height: 634,
    viewBox: "-0.5 -0.5 882 634"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": 0
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": 1
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30.22 40h818v560h-818z",
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-1",
    pointerEvents: "all"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 760,
    height: 520,
    x: 59.22,
    y: 60,
    stroke: "#000",
    strokeWidth: 0.1,
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-2",
    pointerEvents: "all",
    rx: 36.4,
    ry: 36.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0ff",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M841.34 0c0 21.9 17.76 39.66 39.66 39.66v552.68c-21.9 0-39.66 17.76-39.66 39.66H40.66c0-21.9-17.76-39.66-39.66-39.66V39.66C22.9 39.66 40.66 21.9 40.66 0ZM80.32 39.66a79.32 79.32 0 0 1-39.66 39.66v473.36a79.32 79.32 0 0 1 39.66 39.66h721.36a79.32 79.32 0 0 1 39.66-39.66V79.32a79.32 79.32 0 0 1-39.66-39.66Z",
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-3",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-4"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M291.9 255.9h296v116.2h-296z",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("switch", {
    transform: "matrix(2 0 0 2 -.5 -.5)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    width: "100%",
    height: "100%",
    pointerEvents: "none",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 146,
      height: 1,
      paddingTop: 157,
      marginLeft: 147
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #FFB570;",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 52,
      fontFamily: "&quot",
      color: "#ffb570",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Solar")))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,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",
    width: 146,
    height: 75,
    x: 147,
    y: 126.5
  })))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-5"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M291.9 352.72h296v116.2h-296z",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("switch", {
    transform: "matrix(2 0 0 2 -.5 -.5)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    width: "100%",
    height: "100%",
    pointerEvents: "none",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 146,
      height: 1,
      paddingTop: 205,
      marginLeft: 147
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #FFB570;",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 52,
      fontFamily: "&quot",
      color: "#ffb570",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "2")))), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,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",
    width: 146,
    height: 75,
    x: 147,
    y: 174.5
  })))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-6"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M102.72 502.72h202.36v56.2H102.72z",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("switch", {
    transform: "matrix(2 0 0 2 -.5 -.5)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    width: "100%",
    height: "100%",
    pointerEvents: "none",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-start",
      width: 99,
      height: 1,
      paddingTop: 265,
      marginLeft: 53
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #FFB570;",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 15,
      fontFamily: "&quot",
      color: "#ffb570",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Powered")))), _image3 || (_image3 = /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,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",
    width: 99,
    height: 21.75,
    x: 53,
    y: 256.5
  })))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-7"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M575.9 502.72h220v56.2h-220z",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("switch", {
    className: "solarPowered_svg__testTwoClass",
    transform: "matrix(2 0 0 2 -.5 -.5)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    width: "100%",
    height: "100%",
    pointerEvents: "none",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-start",
      width: 108,
      height: 1,
      paddingTop: 265,
      marginLeft: 290
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #FFB570;",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 15,
      fontFamily: "&quot",
      color: "#ffb570",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontStyle: "italic",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }))), _div || (_div = /*#__PURE__*/React.createElement("div", {
    className: "solarPowered_svg__div-svg-hydroSolar"
  })))))), _image4 || (_image4 = /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,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",
    width: 108,
    height: 39.75,
    x: 290,
    y: 247.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-8",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m133 64 30 14.4v3.2L133 96l-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m103 78.4 30 14.41 30-14.41m-30 14.41V96"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-9",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m177 42 30 14.4v3.2L177 74l-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m147 56.4 30 14.41 30-14.41m-30 14.41V74"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-10",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m179 88 30 14.4v3.2L179 120l-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m149 102.4 30 14.41 30-14.41m-30 14.41V120"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-11",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m222.06 66 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m192.06 80.4 30 14.41 30-14.41m-30 14.41V98"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-12",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m137 110 30 14.4v3.2L137 142l-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m107 124.4 30 14.41 30-14.41m-30 14.41V142"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-13",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m77 140 30 14.4v3.2L77 172l-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m47 154.4 30 14.41 30-14.41m-30 14.41V172"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-14",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m267 46 30 14.4v3.2L267 78l-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m237 60.4 30 14.41 30-14.41m-30 14.41V78"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ffb570",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m67.308 196.185 250.604-127.69",
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-15",
    pointerEvents: "all"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#9bdfcf",
    strokeMiterlimit: 10,
    strokeOpacity: 0.8,
    strokeWidth: 4,
    d: "M352.261 215.179 82.84 77.9",
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-16",
    pointerEvents: "all"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#9bdfcf",
    strokeMiterlimit: 10,
    strokeOpacity: 0.8,
    strokeWidth: 4,
    d: "M388.902 188.539 148.918 66.26",
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-17",
    pointerEvents: "all"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#9bdfcf",
    strokeMiterlimit: 10,
    strokeOpacity: 0.8,
    strokeWidth: 4,
    d: "m436.545 168.405-206.25-105.09",
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-18",
    pointerEvents: "all"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#9bdfcf",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    d: "m493.235 139.715-151.81-77.35",
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-19",
    pointerEvents: "all"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#9bdfcf",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    d: "M308.372 236.397 64.628 112.203",
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-20",
    pointerEvents: "all"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-21",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m257 172.8 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m227 187.2 30 14.41 30-14.41m-30 14.41v3.19"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-22",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m301 150.8 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m271 165.2 30 14.41 30-14.41m-30 14.41v3.19"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-23",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m303 196.8 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m273 211.2 30 14.41 30-14.41m-30 14.41v3.19"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-24",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m347 174.8 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m317 189.2 30 14.41 30-14.41m-30 14.41v3.19"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-25",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m245 226.8 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m215 241.2 30 14.41 30-14.41m-30 14.41v3.19"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-26",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m347 128.8 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m317 143.2 30 14.41 30-14.41m-30 14.41v3.19"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-27",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m211 150.8 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m181 165.2 30 14.41 30-14.41m-30 14.41v3.19"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-28",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m257 130.8 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m227 145.2 30 14.41 30-14.41m-30 14.41v3.19"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-29",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m201 248.8 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m171 263.2 30 14.41 30-14.41m-30 14.41v3.19"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-30",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m393 152.8 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m363 167.2 30 14.41 30-14.41m-30 14.41v3.19"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-31",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m435 130.8 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m405 145.2 30 14.41 30-14.41m-30 14.41v3.19"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ffb570",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m61.65 372.2 611-311.32",
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-32",
    pointerEvents: "all"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-33",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m195 203.68 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m165 218.08 30 14.41 30-14.41m-30 14.41v3.19"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-34",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m301 107.56 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m271 121.96 30 14.41 30-14.41m-30 14.41v3.19"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-35",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m389 107.56 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m359 121.96 30 14.41 30-14.41m-30 14.41v3.19"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-36",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m342.98 84 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m312.98 98.4 30 14.41 30-14.41m-30 14.41V116"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#9bdfcf",
    strokeMiterlimit: 10,
    strokeOpacity: 0.8,
    strokeWidth: 4,
    d: "m247.305 268.29-183.03-93.26",
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-37",
    pointerEvents: "all"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#9bdfcf",
    strokeMiterlimit: 10,
    strokeOpacity: 0.8,
    strokeWidth: 4,
    d: "m204.836 288.235-144.872-72.23",
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-38",
    pointerEvents: "all"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#9bdfcf",
    strokeMiterlimit: 10,
    strokeOpacity: 0.8,
    strokeWidth: 4,
    d: "m578.528 97.928-71.156-36.256",
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-39",
    pointerEvents: "all"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-40",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m492.56 102 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m462.56 116.4 30 14.41 30-14.41m-30 14.41V134"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-41",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m157 269.8 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m127 284.2 30 14.41 30-14.41m-30 14.41v3.19"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-42",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m115.36 291.8 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m85.36 306.2 30 14.41 30-14.41m-30 14.41v3.19"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#9bdfcf",
    strokeMiterlimit: 10,
    strokeOpacity: 0.8,
    strokeWidth: 4,
    d: "m159.57 308.903-99.24-50.566",
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-43",
    pointerEvents: "all"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-44",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m445.62 78 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m415.62 92.4 30 14.41 30-14.41m-30 14.41V110"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-45",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m401 56 30 14.4v3.2L401 88l-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m371 70.4 30 14.41 30-14.41m-30 14.41V88"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#9bdfcf",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    d: "M485.793 144.491 323.167 61.63",
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-46",
    pointerEvents: "all"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#9bdfcf",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    d: "m477.889 148.995-171.198-87.23",
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-47",
    pointerEvents: "all"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#9bdfcf",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    d: "M298.547 239.16 62.253 118.76",
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-48",
    pointerEvents: "all"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#9bdfcf",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    d: "M291.362 243.578 67.398 129.462",
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-49",
    pointerEvents: "all"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-50",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m151 181.7 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m121 196.1 30 14.41 30-14.41m-30 14.41v3.19"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-51",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m151 224.82 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m121 239.22 30 14.41 30-14.41m-30 14.41v3.19"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-52",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m107.36 203.68 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m77.36 218.08 30 14.41 30-14.41m-30 14.41v3.19"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-53",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m122.36 255.9 23 11.04v2.5l-23 11.04-23-11.04v-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m99.36 266.94 23 11.05 23-11.05m-23 11.05v2.49"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ffb570",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M69.881 206.856 355.7 61.224",
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-54",
    pointerEvents: "all"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-55",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m87 86 30 14.4v3.2L87 118l-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m57 100.4 30 14.41 30-14.41m-30 14.41V118"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#9bdfcf",
    strokeMiterlimit: 10,
    strokeOpacity: 0.8,
    strokeWidth: 4,
    d: "M536.672 118.743 425.028 61.857",
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-56",
    pointerEvents: "all"
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-57",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m535.18 80.16 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m505.18 94.56 30 14.41 30-14.41m-30 14.41v3.19"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-58",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m488.24 56.16 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m458.24 70.56 30 14.41 30-14.41m-30 14.41v3.19"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-59",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m576.14 60 30 14.4v3.2l-30 14.4-30-14.4v-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m546.14 74.4 30 14.41 30-14.41m-30 14.41V92"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#9bdfcf",
    strokeMiterlimit: 10,
    strokeOpacity: 0.8,
    strokeWidth: 4,
    d: "m622.338 77.962-33.056-16.844",
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-60",
    pointerEvents: "all"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#9bdfcf",
    strokeMiterlimit: 10,
    strokeWidth: 8,
    d: "M60.623 361.788 635.857 68.692",
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-61",
    pointerEvents: "all"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#9bdfcf",
    strokeMiterlimit: 10,
    strokeWidth: 8,
    d: "M67.443 186.212 297.037 69.228",
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-62",
    pointerEvents: "all"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#9bdfcf",
    strokeMiterlimit: 10,
    strokeWidth: 6,
    d: "M68.477 214.82 370.563 60.9",
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-63",
    pointerEvents: "all"
  })), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-64",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m93.36 239.84 23 11.04v2.5l-23 11.04-23-11.04v-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m70.36 250.88 23 11.05 23-11.05m-23 11.05v2.49"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-65",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m84 277.22 23 11.04v2.5L84 301.8l-23-11.04v-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m61 288.26 23 11.05 23-11.05m-23 11.05v2.49"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.7,
    strokeWidth: 0.6,
    "data-cell-id": "3Vf7_YE-0_294Fma0WoW-66",
    pointerEvents: "all"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.7,
    d: "m541.14 53.44 16 7.68v1.76l-16 7.68-16-7.68v-1.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m525.14 61.12 16 7.69 16-7.69m-16 7.69v1.75"
  }))))));
};
export default SvgSolarPowered;